import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  IPositionPickerProps,
  PositionPicker,
} from '@work4all/components/lib/components/entity-picker/position-picker/PositionPicker';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';
import { settings, useSetting } from '../../settings';

interface PositionPickerFieldProps extends IPositionPickerProps {
  error?: string;
  name?: string;
  label?: string;
  required?: boolean;
}

export const PositionPickerField = React.forwardRef<
  HTMLDivElement,
  PositionPickerFieldProps
>(function PositionPickerField(props, ref) {
  const { error, required, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  const positionPickerDescriptionField = useSetting(
    settings.positionPickerDescriptionField()
  );

  return (
    <EntityPickerPopover
      picker={
        <PositionPicker
          {...pickerProps}
          onDescriptionFieldChange={positionPickerDescriptionField.set}
          descriptionField={positionPickerDescriptionField.value}
        />
      }
    >
      <PickerTargetButton
        ref={ref}
        name={props.name}
        value={
          value
            ? `${value.number} ${
                value[positionPickerDescriptionField.value] ||
                value.longtext ||
                value.shortText
              }`
            : ''
        }
        label={props.label ?? t('COMMON.POSITION')}
        error={error}
        onClear={() => {
          onChange(null);
        }}
        required={required}
      />
    </EntityPickerPopover>
  );
});
